var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex justify-content-start"},_vm._l((_vm.formattedValue),function(item){return _c('span',{staticClass:"tag"},[_vm._v("\n    "+_vm._s(item.name)+"\n  ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }